/**
 * Singapura — ROND, RONS & RORC (Existing) chatflow (CSI004). title → 회사 선택 → confirm.
 *   steps/handleEvent 는 형제 aura agm 플로우 재사용. id·taskCode·환영문만 별도.
 */
import type { ConversationMessage } from '@/features/AI-documents/types/docGen.types';
import type { ChatFlow } from '@/features/startTask/preset_task/shared/preset/chatflows/types';
import type { PreSetSelection } from '@/features/startTask/preset_task/shared/preset/types/preset.types';
import { auraAgmFlow } from '../../aura/agm/chatflows/auraAgmFlow';

export const singapuraRegistersFlow: ChatFlow = {
  ...auraAgmFlow,
  id: 'singapura-registers',
  taskCodeMatch: ['CSI004'],
  categoryMatch: ['rond', 'rons', 'rorc', 'nominee', 'controller', 'register'],

  getInitialMessages(_preSet: PreSetSelection): ConversationMessage[] {
    return [
      {
        role: 'ai',
        content:
          `Welcome to **Singapura — ROND, RONS & RORC (Existing)**.\n\n` +
          `This preset prepares three registers together, one copy **per person**:\n` +
          `• **ROND** — Register of Nominee Directors (per director)\n` +
          `• **RONS** — Register of Nominee Shareholders (per shareholder)\n` +
          `• **RORC** — Notice of Controllers (per registrable controller — individual or corporate form)\n\n` +
          `The people are filled from the selected company; add or remove copies per stage as needed.\n\n` +
          `First, enter a **Task Title**, then select the **company**.`,
        timestamp: Date.now(),
        stepId: 1,
        source: 'system',
      },
    ];
  },
};
